import { useEffect, useState } from 'react';
import { apiFetch } from '../api/client.ts';

const FALLBACK = 'support@t3techpartners.com';

let cached: string | null = null;
let fetchPromise: Promise<string> | null = null;

async function loadTicketingEmail(): Promise<string> {
  if (cached) return cached;
  if (!fetchPromise) {
    fetchPromise = apiFetch<{ ticketingEmail: string | null }>('/api/settings/public')
      .then((r) => {
        cached = r.ticketingEmail || FALLBACK;
        return cached;
      })
      .catch(() => {
        cached = FALLBACK;
        return cached;
      });
  }
  return fetchPromise;
}

/**
 * Returns the configured ticketing email address (settable from
 * Admin → Settings). Falls back to the historical default if the
 * settings endpoint is unreachable.
 */
export function useTicketingEmail(): string {
  const [email, setEmail] = useState<string>(cached ?? FALLBACK);
  useEffect(() => {
    void loadTicketingEmail().then((v) => setEmail(v));
  }, []);
  return email;
}
